import type { FC, MouseEvent } from "react";
import { Link as RouterLink, useSearchParams } from "react-router-dom";
import Button from "@mui/material/Button";
import MuiLink from "@mui/material/Link";
import { renderContractPaymentStatus } from "./billingLabels";
import { contractPaymentCardHref } from "./contractPaymentCardHelpers";

interface StatusLinkProps {
  payment: { id: string; status: string; expired?: boolean | null };
  /** Путь страницы платежей, когда ссылка живёт внутри чужого диалога. */
  cardPath?: string;
}

// Клик по ссылке в строке таблицы не должен доходить до обработчика строки.
const stop = (event: MouseEvent) => event.stopPropagation();

/** Чип статуса ссылкой в карточку платежа (спека 2026-10-16 §4.1). */
export const ContractPaymentStatusLink: FC<StatusLinkProps> = ({
  payment,
  cardPath,
}) => {
  const [searchParams] = useSearchParams();
  return (
    <MuiLink
      component={RouterLink}
      to={contractPaymentCardHref(searchParams, payment.id, cardPath)}
      underline="none"
      aria-label="Открыть карточку платежа"
      onClick={stop}
      sx={{ display: "inline-flex" }}
    >
      {renderContractPaymentStatus(payment.status, payment.expired)}
    </MuiLink>
  );
};

/** «Открыть» в колонке действий: та же ссылка, что у статуса. */
export const OpenContractPaymentButton: FC<{
  paymentId: string;
  cardPath?: string;
}> = ({ paymentId, cardPath }) => {
  const [searchParams] = useSearchParams();
  return (
    <Button
      size="small"
      variant="outlined"
      component={RouterLink}
      to={contractPaymentCardHref(searchParams, paymentId, cardPath)}
      onClick={stop}
    >
      Открыть
    </Button>
  );
};
